// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetBusinessUnitByPostalCodeRequestViewModel from '../../viewModel/request/BusinessUnits/GetBusinessUnitByPostalCodeRequestViewModel';
import BusinessUnitResourceViewModel from '../../viewModel/resource/BusinessUnitResourceViewModel';

export default (service: Servicelayer) => ({
  /**  */
  async getBusinessUnitByPostalCode(request: GetBusinessUnitByPostalCodeRequestViewModel, config?: RequestConfig) {
    const requestDTO = request.toDTO();
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-business-unit-by-postal-code'] ?? 'BusinessUnits/PostalCode';
    const response = await service.get<any>(endpointPath, {
      query: {
        postalCode: requestDTO.postalCode,
        postalCodeAddition: requestDTO.postalCodeAddition,
      },
      ...config,
    });
    const dto = response.data.result;
    return new BusinessUnitResourceViewModel().fromDTO(dto);
  },
  /**  */
  async getBusinessUnitByUserId(userId: number, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-business-unit-by-user-id'] ?? 'BusinessUnits/UserId/{userId}';
    endpointPath = endpointPath.replace(/\{userId\}/g, `${userId}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new BusinessUnitResourceViewModel().fromDTO(dto);
  },
  /**  */
  async getBusinessUnitById(id: string, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-business-unit-by-id'] ?? 'BusinessUnits/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new BusinessUnitResourceViewModel().fromDTO(dto);
  },
});
